import { Component, inject, model, signal, computed } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { SelectCategoryComponent } from '../select-category/select-category.component';
import { SearchType } from '../../../enums/search-type';
import { AnswerSearch } from '../../../models/recent-search';
import { TranslateModule } from '@ngx-translate/core';
import { CategoriesQuickSearch } from '../../../models/categories-quick-search';
import { SliceArrayItemsPipe } from '../../../pipes/slice-array-items.pipe';
import { ClickOutsideDirective } from '../../../directives/click-outside.directive';
import { ChangeLanguagePipe } from '../../../pipes/change-language.pipe';
import { OpenSearchService } from '../../../services/open-search.service';
import { MatDividerModule } from '@angular/material/divider';
import { LessonsProjectService } from '../../../services/lessons-project.service';
import { conversations } from '../../../models/recentSearchModel';
import { OpenSearchDrawerService } from '../../../services/open-search-drawer.service';
import { DrawerSearchPanelService } from '../../../services/drawer-search-panel.service';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RecentSearchCleanFormatPipe } from '../../../pipes/recent-search-clean-format.pipe';

@Component({
  selector: 'app-search-panel',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    DatePipe,
    SelectCategoryComponent,
    TranslateModule,
    SliceArrayItemsPipe,
    ClickOutsideDirective,
    ChangeLanguagePipe,
    MatDividerModule,
    MatPaginatorModule,
    RecentSearchCleanFormatPipe,
  ],
  templateUrl: './search-panel.component.html',
  styleUrl: './search-panel.component.scss',
})
export class SearchPanelComponent {
  searchType = model<SearchType>();
  items = model<AnswerSearch[]>();
  isShowAllResults = model<boolean>(false);
  isSelecteditem = model<boolean>();
  showSearchPanel = model<boolean>();
  isSmallVersion = model<boolean>();
  showAllResults = model<boolean>(false);
  categoryOptions = model<CategoriesQuickSearch[]>([]);
  showAll = model<boolean>(false);
  showAllSignal = computed(() => this.showAll());
  quick = signal(SearchType.QUICK);
  recent = signal(SearchType.RECENT);
  openSearchService = inject(OpenSearchService);
  ProjectsService = inject(LessonsProjectService);
  openSearchDrawerService = inject(OpenSearchDrawerService);
  drawerSearchPanel = inject(DrawerSearchPanelService);
  private changeLanguagePipe = inject(ChangeLanguagePipe);
  filteredItems = model<AnswerSearch[]>();
  currentQuickItems = computed(() => this.filteredItems() || []);
  currentRecentItems = computed(() => {
    const recentData = this.openSearchService.recentSearches();
    return recentData.length > 0 ? recentData[0].recentConversations : [];
  });
  recentSearchItems = computed(() => this.openSearchService.recentSearches() || []);
  Projectslength = computed(
    () =>
      this.ProjectsService.projects().underPreparation.operationDetail.length > 0 ||
      this.ProjectsService.projects().execution.operationDetail.length > 0,
  );

  recentSearchMeta = computed(() => {
    const data = this.openSearchService.recentSearches();
    return data.length > 0 ? data[0] : null;
  });

  totalItems = computed(() => this.recentSearchMeta()?.totalCount ?? 0);
  totalPages = computed(() => this.recentSearchMeta()?.totalPages ?? 0);
  currentPage = computed(() => this.recentSearchMeta()?.pageNumber ?? 1);
  pageSize = computed(() => this.recentSearchMeta()?.pageSize ?? 10);

  currentPageStart = computed(() =>
    this.totalItems() === 0 ? 0 : (this.currentPage() - 1) * this.pageSize() + 1,
  );

  currentPageEnd = computed(() =>
    Math.min(this.currentPage() * this.pageSize(), this.totalItems()),
  );
  ngOnInit() {
    this.openSearchService.pageRecentSearch.set(1);
  }
  onNextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.openSearchService.pageRecentSearch.set(this.currentPage() + 1);
      this.openSearchService.getRecentSeaeches();
    }
  }

  onPreviousPage() {
    if (this.currentPage() > 1) {
      this.openSearchService.pageRecentSearch.set(this.currentPage() - 1);
      this.openSearchService.getRecentSeaeches();
    }
  }

  onClickItem(item: number | conversations) {
    if (this.searchType() === SearchType.RECENT && typeof item !== 'number') {
      const conversation = item;
      this.openSearchService.conversationIdSignal.set(conversation.id);
      this.openSearchService.postConversations(conversation.id);
      this.showSearchPanel.set(false);
      this.showAllResults.set(false);
      this.openSearchService.historyResponse.set(null);
      this.drawerSearchPanel.close();
    } else if (typeof item === 'number') {
      const copyItems = [...(this.items() || [])];
      copyItems.forEach((x, i) => (x.selected = i === item));
      this.items.set(copyItems);
      this.isSelecteditem.set(true);
      this.showSearchPanel.set(false);
      const selectedItem = copyItems[item];
      if (selectedItem?.text) {
        const text = this.changeLanguagePipe.transform(selectedItem.text);
        if (text) {
          this.drawerSearchPanel.selectedPromptText.set(
            text.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, ''),
          );
        }
      }
      this.drawerSearchPanel.close();
    }
  }

  onShowExploreAll = () => {
    localStorage.removeItem('OpenSearchPath');
    this.openSearchService._dataOpenLogic.set(null);
    this.openSearchService.historyResponse.set(null);
    this.openSearchService.conversationIdSignal.set(null);
    this.isShowAllResults.set(true);
    this.showAllResults.set(true);
  };

  setShowSearchPanel = (value: boolean) => this.showSearchPanel.set(value);

  handleClickOutside() {
    if (this.isSmallVersion()) {
      this.setShowSearchPanel(false);
    }
  }
}
